import { commonTexts, enrollmentTexts } from 'consts/text';
import { UserRemoveIcon } from 'assets';
import {
    AppConfirmModal,
    AppConfirmModalProps,
} from 'components/organisms/AppConfirmModal/AppConfirmModal';

export const ChildEnrollmentRejectModal = ({
    open,
    onCancel,
}: Pick<AppConfirmModalProps, 'open' | 'onCancel'>) => (
    // TODO: to add mutation logic
    <AppConfirmModal
        open={open}
        isMobileFullScreenMode={false}
        // TODO: to pass loading status from useAppMutation
        // confirmActionLoading={}
        title={enrollmentTexts.rejectChildEnrollment.title}
        text={enrollmentTexts.rejectChildEnrollment.description}
        icon={<UserRemoveIcon />}
        width={520}
        okButtonProps={{
            title: enrollmentTexts.rejectChildEnrollment.okButtonText,
            danger: true,
        }}
        cancelButtonProps={{ title: commonTexts.actionLabels.goBack }}
        // TODO: to pass mutate function from useAppMutation
        // onOk={}
        onCancel={onCancel}
    />
);
